import * as Cesium from 'cesium'
const materialType = 'PolylineDirection'
/**
 * 带方向的线材质
 */
export class PolylineDirectionMaterial {
    private _color: Cesium.Color|string;
    private _definitionChanged: Cesium.Event;
    constructor (options:{color?:string|Cesium.Color} = {}) {
      this._color = options.color || new Cesium.Color(0, 213 / 255, 143 / 255, 1)
      this._definitionChanged = new Cesium.Event()

      this._registerMaterialType()
    }

    _registerMaterialType () {
      if (!Cesium.Material[materialType]) {
        Cesium.Material.PolylineDirectionType = materialType
        Cesium.Material._materialCache.addMaterial(materialType, {
          fabric: {
            type: materialType,
            uniforms: {
              color: this._color,
              directionColor: new Cesium.Color(1, 1, 1, 1),
              outlineColor: new Cesium.Color(1, 1, 1, 1),
              outlineWidth: 0
            },
            source: this._getShaderSource()
          },
          translucent: true
        })
      }
    }

    _getShaderSource () {
      return `
      #ifdef GL_OES_standard_derivatives
      #extension GL_OES_standard_derivatives : enable
      #endif
      
      uniform vec4 color;
      uniform vec4 directionColor;
      uniform vec4 outlineColor;
      uniform float outlineWidth;
      
      in float v_width;
      in float v_polylineAngle;
      
      const float fragLength = 100.0;
      const float startPosition = 0.45;
      const float endPosition = 0.55;
      
      mat2 rotate(float rad) {
        float c = cos(rad);
        float s = sin(rad);
        return mat2(c, s, -s, c);
      }
      
      float getPointOnLine(vec2 p0, vec2 p1, float x) {
        float slope = (p0.y - p1.y) / (p0.x - p1.x);
        return slope * (x - p0.x) + p0.y;
      }
      
      czm_material czm_getMaterial(czm_materialInput materialInput) {
        czm_material material = czm_getDefaultMaterial(materialInput);
        vec2 st = materialInput.st;
        
        float halfInteriorWidth = 0.5 * (v_width - outlineWidth) / v_width;
        float b = step(0.5 - halfInteriorWidth, st.t);
        b *= 1.0 - step(0.5 + halfInteriorWidth, st.t);
        
        float d1 = abs(st.t - (0.5 - halfInteriorWidth));
        float d2 = abs(st.t - (0.5 + halfInteriorWidth));
        float dist = min(d1, d2);
        
        vec4 currentColor = mix(outlineColor, color, b);
        vec4 outColor = czm_antialias(outlineColor, color, currentColor, dist);
        outColor = czm_gammaCorrect(outColor);
        
        vec2 pos = rotate(v_polylineAngle) * gl_FragCoord.xy;
        
        float maskS = fract(pos.x / (fragLength * czm_pixelRatio));
        float maskT = st.t;
        bool isDirection = (maskS > startPosition) && (maskS <= endPosition);
        vec4 fragColor;
        
        if (isDirection) {
          float arrowWidth = (endPosition - startPosition) / 2.0;
          float midS = startPosition + arrowWidth;
          
          float t = 1.0;
          if (maskS < midS) {
            vec2 center = vec2(midS, 0.5);
            float ptOnUpperLine = getPointOnLine(vec2(startPosition, 1.0), center, maskS);
            float ptOnLowerLine = getPointOnLine(vec2(startPosition, 0.0), center, maskS);
            
            t *= 1.0 - step(ptOnUpperLine, maskT);
            t *= step(ptOnLowerLine, maskT);
            t = 1.0 - t;
          } else {
            vec2 center = vec2(endPosition, 0.5);
            float ptOnUpperLine = getPointOnLine(vec2(midS, 1.0), center, maskS);
            float ptOnLowerLine = getPointOnLine(vec2(midS, 0.0), center, maskS);
            
            t *= 1.0 - step(ptOnUpperLine, maskT);
            t *= step(ptOnLowerLine, maskT);
          }
          
          vec4 outsideColor = outColor;
          vec4 currentColor = mix(outsideColor, directionColor, clamp(t, 0.0, 1.0));
          fragColor = currentColor;
        } else {
          fragColor = outColor;
        }
        
        fragColor = czm_gammaCorrect(fragColor);
        material.diffuse = fragColor.rgb;
        material.alpha = fragColor.a;
        return material;
      }`
    }

    get isConstant () {
      return false
    }

    get definitionChanged () {
      return this._definitionChanged
    }

    get color () {
      return this._color
    }

    set color (value) {
      if (!Cesium.Color.equals(this._color, value)) {
        this._color = value
        this._definitionChanged.raiseEvent(this)
      }
    }

    getType () {
      return 'PolylineDirection'
    }

    getValue (time, result) {
      if (!Cesium.defined(result)) {
        result = {}
      }

      result.color = this._color
      return result
    }

    equals (other) {
      return this === other
    }
}
